// extracted by mini-css-extract-plugin
export default {"container":"changes_container__TSY8r","heading":"changes_heading__dRyyu"};